/**
 * Created by Ning Jiang on 2024-09-30.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {ElGordosRevenge} from "../../ElGordosRevenge";
import {TimelineLite} from "gsap";
import {ElGordosRevengeSound} from "../../sound/ElGordosRevengeSound";

export class LastReelFSLandingController extends ReelStopPresentationController {

    constructor() {
        super("LastReelFSLandingController");
    }

    protected onReelBounce(data:IReelStateEventData):Promise<any> {
        const gameData = ElGordosRevenge.model.parsedGameData;
        if(gameData.mode != GameMode.FREESPIN) {
            return Promise.resolve();
        }

        if(data.reelId < 5) {
            return Promise.resolve();
        }

        const lastSym = ElGordosRevenge.reels[5].getSymbol(0);
        if(lastSym.stackedSymbolName.symName.includes("S2")) {
            return Promise.resolve();
        }

        if(!lastSym.stackedSymbolName.symName.includes(gameData.lastReelMultiFS.multiplierMid)) {
            debugger;
            throw new Error(`LastReelFSLandingController: Last symbol name doesn't match data lastReelMultiFS.multiplierMid!`);
        }
        const tl = new TimelineLite();
        tl.add([
            lastSym.showMultiplier(gameData.lastReelMultiFS.midMultiplier, true),
            () => {
                ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.FS_LAST_REEL_MULTI_LAND});
            }
        ]);
        const timeStamp = tl.totalDuration() + 0.1;
        let hasSymbol = false;
        for(let reelId = 0; reelId < 5; reelId++) {
            for(let symId = 0; symId < 3; symId++) {
                const sym = ElGordosRevenge.reels[reelId].getSymbol(symId);
                if(sym.symbolName === gameData.lastReelMultiFS.multiplierMid) {
                    hasSymbol = true;
                    tl.add(sym.showMultiplier(gameData.lastReelMultiFS.midMultiplier, true), timeStamp);
                }
            }
        }
        if(hasSymbol) {
            tl.add(() => {
                ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.FS_LAST_REEL_MULTI_INFECT});
            }, timeStamp);
        }

        if(tl.totalDuration() > 0) {
            return Promise.resolve(tl);
        } else {
            return Promise.resolve();
        }
    }
}